import { Box } from "@mui/material";
import { useRouterState } from "@tanstack/react-router";

import { NOT_WIDE, TINY } from "@/components/marketing/tokens";
import { FooterBand } from "../MarketingFooter";
import { BrandColumn, Wordmark } from "./FooterBrand";
import { Copyright } from "./FooterLegal";
import { FooterLink } from "./FooterNav";
import type { FooterLink as FooterLinkItem } from "./footerContent";

/** The three policies the paid-search footer links to, in its order. */
const POLICY_LINKS: FooterLinkItem[] = [
  { label: "Terms of Service", href: "/terms" },
  { label: "Privacy Policy", href: "/privacy-policy" },
  { label: "Compliance Policy", href: "/compliance-policy" },
];

/**
 * `.ppc-footer_row` in the site's own band: the paid-search pages close on
 * the wordmark and the copyright beside three policy links, one row centred
 * on its axis, a column below the wide step.
 */
export default function PpcFooter() {
  const pathname = useRouterState({
    select: (state) => state.location.pathname,
  });
  const here = pathname.replace(/\/$/, "");

  return (
    <FooterBand>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          [NOT_WIDE]: {
            flexDirection: "column",
            alignItems: "flex-start",
            gap: "32px",
          },
          [TINY]: { columnGap: 0 },
        }}
      >
        <BrandColumn>
          <Wordmark flush />
          <Copyright />
        </BrandColumn>
        {/* `.ppc-footer_list`: a row of three, 16 apart. */}
        <Box component="nav" aria-label="Policies">
          <Box
            component="ul"
            sx={{
              display: "flex",
              gap: "16px",
              listStyle: "none",
              m: "0 0 10px",
              p: 0,
            }}
          >
            {POLICY_LINKS.map((item) => (
              <Box component="li" key={item.href} sx={{ my: "6px" }}>
                <FooterLink item={item} current={item.href === here} />
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </FooterBand>
  );
}
